// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Expenses_title__eYJMo {
  margin-bottom: 28px;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
}

.Expenses_subtitle__JMzdY {
  margin-bottom: 28px;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}

.Expenses_form__hwYJk {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.Expenses_inputs__fUqMH {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin-bottom: 70px;
}

.Expenses_half-width-inputs__kZMzO {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Expenses_container__SewHu {
  display: flex;
  justify-content: center;
}

.Expenses_pricetag__4zEGK {
  margin-bottom: 28px;
  font-size: 1.25rem;
  line-height: 36px;
  color: #1414ff;
}

.Expenses_numbers__2zaAI {
  font-size: 2rem;
}

.Expenses_button__zd9G9 {
  width: 200px;
}

.Expenses_input-error__0-xKL {
  margin-top: 4px;
  padding: 0 8px;
  color: #b94402;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}
.Expenses_input-error__0-xKL .Expenses_input-error-prefix__URCrl {
  margin: 0;
  padding: 0 20px;
}

@media screen and (max-width: 600px) {
  .Expenses_inputs__fUqMH {
    margin-bottom: 32px;
  }
  .Expenses_subtitle__JMzdY {
    font-size: 1rem;
  }
  .Expenses_half-width-inputs__kZMzO {
    flex-direction: row;
    gap: 13px;
  }
  .Expenses_button__zd9G9 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/Expenses/Expenses.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCPS;ADWX;;AADA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAIF;;AADA;EACE,aAAA;EACA,uBAAA;AAIF;;AADA;EACE,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cC3CS;AD+CX;;AADA;EACE,eAAA;AAIF;;AADA;EACE,YAAA;AAIF;;AADA;EACE,eAAA;EACA,cAAA;EACA,cCpCW;EDqCX,gBAAA;EACA,eAAA;EACA,iBAAA;AAIF;AAFE;EACE,SAAA;EACA,eAAA;AAIJ;;AAAA;EACE;IACE,mBAAA;EAGF;EAAA;IACE,eAAA;EAEF;EACA;IACE,mBAAA;IACA,SAAA;EACF;EAEA;IACE,WAAA;EAAF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.title {\n  margin-bottom: 28px;\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 48px;\n}\n\n.subtitle {\n  margin-bottom: 28px;\n  font-size: 20px;\n  line-height: 36px;\n  color: colors.$primary8;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  margin-bottom: 70px;\n}\n\n.half-width-inputs {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.container {\n  display: flex;\n  justify-content: center;\n}\n\n.pricetag {\n  margin-bottom: 28px;\n  font-size: 1.25rem;\n  line-height: 36px;\n  color: colors.$primary5;\n}\n\n.numbers {\n  font-size: 2rem;\n}\n\n.button {\n  width: 200px;\n}\n\n.input-error {\n  margin-top: 4px;\n  padding: 0 8px;\n  color: colors.$attention7;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n\n  .input-error-prefix {\n    margin: 0;\n    padding: 0 20px;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .inputs {\n    margin-bottom: 32px;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n\n  .half-width-inputs {\n    flex-direction: row;\n    gap: 13px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"title": `Expenses_title__eYJMo`,
	"subtitle": `Expenses_subtitle__JMzdY`,
	"form": `Expenses_form__hwYJk`,
	"inputs": `Expenses_inputs__fUqMH`,
	"half-width-inputs": `Expenses_half-width-inputs__kZMzO`,
	"container": `Expenses_container__SewHu`,
	"pricetag": `Expenses_pricetag__4zEGK`,
	"numbers": `Expenses_numbers__2zaAI`,
	"button": `Expenses_button__zd9G9`,
	"input-error": `Expenses_input-error__0-xKL`,
	"input-error-prefix": `Expenses_input-error-prefix__URCrl`
};
export default ___CSS_LOADER_EXPORT___;
